import { INITIAL_DROPDOWN_ITEMS } from './dropDown/dropDownItemsStore';
import { DropDownItemsStoreType } from './dropDown/dropDownItemsStore.types';
import { INITIAL_FILTERS } from './filters/filtersStore';
import { FiltersStoreType } from './filters/filtersStore.types';
import { INITAL_LABEL } from './labels/labelsStore';
import { LabelsStoreType } from './labels/labelsStore.types';
import { INITIAL_LANGUAGE } from './language/languageStore';
import { LanguageStoreType } from './language/languageStore.types';
import { INITIAL_PROJECT_DATA } from './projectData/projectDataStore';
import { ProjectDataStoreType } from './projectData/projectDataStore.types';
import { INITIAL_PROJECTS_OVERVIEW } from './projectsOverview/projectsOverviewStore';
import { ProjectsOverviewStoreType } from './projectsOverview/projectsOverviewStore.types';
import { INITIAL_SHOW_FILTER } from './showFilter/showFilterStore';
import { ShowFilterStoreType } from './showFilter/showFilterStore.types';
import { INITIAL_IS_MOBILE_VIEW } from './windowWidth/windowWidthStore';
import { WindowWidthStoreType } from './windowWidth/windowWidthStore.types';
import { INITIAL_SITEMAP } from './sitemap/sitemapStore';
import { SitemapStoreType } from './sitemap/sitemapStore.types';
import { BaseUrlStoreType } from './baseUrl/baseUrlStore.types';
import { INITIAL_BASE_URL } from './baseUrl/baseUrlStore';
import { INITIAL_PROJECT_REQUEST_COUNT } from './projectRequestCount/projectRequestCountStore';
import { ProjectRequestCountStoreType } from './projectRequestCount/projectRequestCountStore.types';

interface Store {
  projectsOverview: ProjectsOverviewStoreType;
  dropDown: DropDownItemsStoreType;
  filters: FiltersStoreType;
  sitemap: SitemapStoreType;
  baseUrl: BaseUrlStoreType;
  labels: LabelsStoreType;
  language: LanguageStoreType;
  showFilter: ShowFilterStoreType;
  projectData: ProjectDataStoreType;
  isMobileView: WindowWidthStoreType;
  projectRequestCount: ProjectRequestCountStoreType;
}

export const initials = {
  projectsOverview: INITIAL_PROJECTS_OVERVIEW,
  dropDown: INITIAL_DROPDOWN_ITEMS,
  filters: INITIAL_FILTERS,
  sitemap: INITIAL_SITEMAP,
  baseUrl: INITIAL_BASE_URL,
  labels: INITAL_LABEL,
  language: INITIAL_LANGUAGE,
  showFilter: INITIAL_SHOW_FILTER,
  projectData: INITIAL_PROJECT_DATA,
  isMobileView: INITIAL_IS_MOBILE_VIEW,
  projectRequestCount: INITIAL_PROJECT_REQUEST_COUNT,
};

export type { Store };
